import * as Sentry from '@sentry/browser';

import options from './options';

Sentry.init(options);
